export const FETCH_TAGS = 'FETCH_TAGS';
export const FETCH_TAGS_SUCCESS = 'FETCH_TAGS_SUCCESS';

export const CLEAR_TAGS = "CLEAR_TAGS";